export class RouteLookup {
  routeName: string;
}
